import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';

function DeleteConfirmDialog({ open, onClose, onConfirm }) {
  const { t } = useTranslation();
  
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('observations.deleteObservation')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('observations.confirmDelete')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('observations.cancel')}</Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {t('observations.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteConfirmDialog;
